"use strict";

import Form from "./form";

class EntityForm extends Form {
    constructor() {
        super();
        this.form = $("#recordForm form");
        this.isActiveForm = $("#is_active").parent();
        this.image = this.form.find(".image");
        this.coverImage = this.form.find(".coverImage");
        this.imageUploadBtn = this.form.find(".imageUploadBtn");
        this.coverImgUploadBtn = this.form.find(".coverImgUploadBtn");
        this.imageDeleteBtn = this.form.find(".imageDeleteBtn");
        this.videoFileUploadBtn = this.form.find(".videoFileUploadBtn");
        this.videoFileDeleteBtn = this.form.find(".videoFileDeleteBtn");
        this.coverImgDeleteBtn = this.form.find(".coverImgDeleteBtn");
        this.inputEyeIcons = this.form.find(".inputEyeIcon");
        this.alertIconPath = this.form.find(".icon_path");
        this.alertIconPathUploadBtn = this.form.find(".alertIconPathUploadBtn");
        this.alertIconPathDeleteBtn = this.form.find(".alertIconPathDeleteBtn");
    }

    formMenuScrollHandler() {
        $(window).on("scroll", () => {
            if ($(window).scrollTop() > 70) {
                $(".topMenu").css("top", 0);
            } else {
                $(".topMenu").css("top", "100px");
            }
        });
    }

    uploadImage(e, imageUploadBtn) {
        const filePreview = $(e.target)
            .closest(".parentImageUploadBtn")
            .prev(".filePreview");

        window.processSelectedImage = function (
            filePaths,
            tmbs,
            requestingField
        ) {
            filePreview
                .find("." + requestingField)
                .val(filePaths[0])
                .trigger("change");
            filePreview.find("img").attr("src", tmbs[0]);
        };

        imageUploadBtn.colorbox({
            href: imageUploadBtn.data("filemanagerroute"),
            width: "80%",
            height: "80%",
            fastIframe: true,
            iframe: true,
            onClosed: function () {
                if (filePreview.find("img").attr("src")) {
                    filePreview.removeClass("hidden");
                }
            },
        });
    }

    deleteImage(e) {
        e.preventDefault();
        const imageDeleteBtn = $(e.target).closest(".imageDeleteBtn"),
            image = imageDeleteBtn
                .closest(".parentImageUploadBtn")
                .prevAll(".image"),
            filePreview = imageDeleteBtn
                .closest(".parentImageUploadBtn")
                .prev(".filePreview");

        if (!confirm("Are you sure you want to delete this image?")) {
            return false;
        }
        $.ajax({
            headers: {
                "X-CSRF-Token": this.form.find('input[name="_token"]').val(),
            },
            url: imageDeleteBtn.data("deleteimageroute"),
            type: "PATCH",
        }).done(() => {
            image
                .find("img")
                .attr("src", image.find("img").data("default-image"));
            imageDeleteBtn.addClass("hidden");
            filePreview.find(".image").val("");
        });
    }

    uploadCoverImg(e, coverImgUploadBtn) {
        const filePreview = $(e.target)
            .closest(".parentCoverImgUploadBtn")
            .prev(".filePreview");

        const imgEl = filePreview.find("img");
        const spinner = filePreview.find(".spinner-border");

        window.processSelectedCoverImg = function (
            filePaths,
            tmbs,
            requestingField
        ) {
            filePreview
                .find("." + requestingField)
                .val(filePaths[0])
                .trigger("change");

            const src = tmbs[0] ?? "/storage/" + filePaths[0];

            imgEl.attr("src", src);

            if (!tmbs[0] && filePaths[0]?.toLowerCase().endsWith(".svg")) {
                spinner.removeClass("d-none");
                imgEl.hide();

                setTimeout(() => {
                    imgEl.attr("src", src + "?" + Date.now()).show();
                    spinner.addClass("d-none");
                }, 1000);
            } else {
                spinner.addClass("d-none");
                imgEl.show();
            }
        };

        coverImgUploadBtn.colorbox({
            href: coverImgUploadBtn.data("filemanagerroute"),
            width: "80%",
            height: "80%",
            fastIframe: true,
            iframe: true,
            onClosed: function () {
                if (filePreview.find("img").attr("src")) {
                    filePreview.removeClass("hidden");
                }
            },
        });
    }

    deleteCoverImg(e) {
        e.preventDefault();
        const coverImgDeleteBtn = $(e.target).closest(".coverImgDeleteBtn"),
            coverImage = coverImgDeleteBtn
                .closest(".parentCoverImgUploadBtn")
                .prevAll(".coverImage"),
            filePreview = coverImgDeleteBtn
                .closest(".parentCoverImgUploadBtn")
                .prev(".filePreview");

        if (!confirm("Are you sure you want to delete this image?")) {
            return false;
        }
        $.ajax({
            headers: {
                "X-CSRF-Token": this.form.find('input[name="_token"]').val(),
            },
            url: coverImgDeleteBtn.data("deletecoverimageroute"),
            type: "PATCH",
        }).done(() => {
            coverImage
                .find("img")
                .attr("src", coverImage.find("img").data("default-image"));
            coverImgDeleteBtn.addClass("hidden");
            filePreview.find(".cover_image").val("");
        });
    }

    uploadAlertIconPath(e, alertIconPathUploadBtn) {
        const filePreview = $(e.target)
            .closest(".parentAlertIconPathUploadBtn")
            .prev(".filePreview");

        const imgEl = filePreview.find("img");
        const spinner = filePreview.find(".spinner-border");

        window.processSelectedAlertIconPath = function (
            filePaths,
            tmbs,
            requestingField
        ) {
            const selectedPath = filePaths[0] ?? "";
            const normalizedPath = selectedPath
                ? selectedPath.replace(/^\/+/, "").startsWith("storage/")
                    ? selectedPath.replace(/^\/+/, "")
                    : `storage/${selectedPath.replace(/^\/+/, "")}`
                : "";

            filePreview
                .find("." + requestingField)
                .val(normalizedPath)
                .trigger("change");

            const src = tmbs[0] ?? `/${normalizedPath}`;

            imgEl.attr("src", src);

            if (!tmbs[0] && filePaths[0]?.toLowerCase().endsWith(".svg")) {
                spinner.removeClass("d-none");
                imgEl.hide();

                setTimeout(() => {
                    imgEl.attr("src", src + "?" + Date.now()).show();
                    spinner.addClass("d-none");
                }, 1000);
            } else {
                spinner.addClass("d-none");
                imgEl.show();
            }
        };

        alertIconPathUploadBtn.colorbox({
            href: alertIconPathUploadBtn.data("filemanagerroute"),
            width: "80%",
            height: "80%",
            fastIframe: true,
            iframe: true,
            onClosed: function () {
                if (filePreview.find("img").attr("src")) {
                    filePreview.removeClass("hidden");
                }
            },
        });
    }

    deleteAlertIconPath(e) {
        e.preventDefault();
        const alertIconPathDeleteBtn = $(e.target).closest(".alertIconPathDeleteBtn"),
            alertIconPath = alertIconPathDeleteBtn
                .closest(".parentAlertIconPathUploadBtn")
                .prevAll(".coverImage"),
            filePreview = alertIconPathDeleteBtn
                .closest(".parentAlertIconPathUploadBtn")
                .prev(".filePreview");

        if (!confirm("Are you sure you want to delete this image?")) {
            return false;
        }
        $.ajax({
            headers: {
                "X-CSRF-Token": this.form.find('input[name="_token"]').val(),
            },
            url: alertIconPathDeleteBtn.data("deletealerticonpathroute"),
            type: "PATCH",
        }).done(() => {
            alertIconPath
                .find("img")
                .attr("src", alertIconPath.find("img").data("default-image"));
            alertIconPathDeleteBtn.addClass("hidden");
            filePreview.find(".icon_path").val("");
        });
    }

    uploadVideoFile(e, videoFileUploadBtn) {
        const filePreview = $(e.target)
            .closest(".parentVideoFileUploadBtn")
            .prev(".filePreview");

        window.processSelectedVideoFile = function (
            filePaths,
            tmbs,
            requestingField
        ) {
            filePreview
                .find("." + requestingField)
                .val(filePaths[0])
                .trigger("change");
            filePreview.find("video source").attr("src", '/storage/' + filePaths[0]);
        };

        videoFileUploadBtn.colorbox({
            href: videoFileUploadBtn.data("filemanagerroute"),
            width: "80%",
            height: "80%",
            fastIframe: true,
            iframe: true,
            onClosed: function () {
                if (filePreview.find("video source").attr("src")) {
                    filePreview.removeClass("hidden");

                }
            },
        });
    }

    deleteVideoFile(e) {
        e.preventDefault();
        const videoFileDeleteBtn = $(e.target).closest(".videoFileDeleteBtn"),
            videoFile = videoFileDeleteBtn
                .closest(".parentVideoFileUploadBtn")
                .prevAll(".videoFile"),
            filePreview = videoFileDeleteBtn
                .closest(".parentVideoFileUploadBtn")
                .prev(".filePreview");

        if (!confirm("Are you sure you want to delete this video file?")) {
            return false;
        }
        $.ajax({
            headers: {
                "X-CSRF-Token": this.form.find('input[name="_token"]').val(),
            },
            url: videoFileDeleteBtn.data("deletevideofileroute"),
            type: "PATCH",
        }).done(() => {
            videoFile
                .find("video").remove();
            videoFileDeleteBtn.addClass("hidden");
            filePreview.find(".video_file").val("");
        });
    }

    togglePasswordVisibility(e) {
        const input = $(e.currentTarget).prev("input");
        if (input.attr("type") === "password") {
            input.attr("type", "text");
        } else {
            input.attr("type", "password");
        }
    }

    recordFormMenuPosition() {
        $(window).on("scroll", function () {
            let menu = $(".recordFormMenu");

            if ($(this).scrollTop() > 40) {
                menu.addClass("fixed-top");
            } else {
                menu.removeClass("fixed-top");
            }
        });
    }
}

export default EntityForm;
